<template>
  <div v-if="step1">
    <Stepper
        stepInfo="Step 1 of 7"
        description="Make sure you can receive money"
      />
  </div>
  <div v-else-if="step2">
    <Stepper
        stepInfo="Step 2 of 7"
        description="Describe your situation"
      />
  </div>
  <div v-else-if="step3">
    <Stepper
        stepInfo="Step 3 of 7"
        description="Add details"
      />
  </div>
  <div v-else-if="step4">
    <Stepper
        stepInfo="Step 4 of 7"
        description="Document your emergency"
      />
  </div>
  <div v-else-if="step5">
    <Stepper
        stepInfo="Step 5 of 7"
        description="Document expenses and amounts needed"
      />
  </div>
  <div v-else-if="step5alt">
    <Stepper
        stepInfo="Step 5 of 7"
        description="Describe expenses and amounts needed"
      />
  </div>
  <div v-else-if="step6">
    <Stepper
        stepInfo="Step 6 of 7"
        description="Document your expenses"
      />
  </div>
  <div v-else-if="step7">
    <Stepper
        stepInfo="Step 7 of 7"
        description="Request Summary"
      />
  </div>
</template>

<script>
import Stepper from '@/components/requests/Stepper'

export default {
  name: 'RequestStepProgressBar',
  components: {
    Stepper
  },
  props: {
    step1: {
      type: Boolean,
    },
    step2: {
      type: Boolean,
    },
    step3: {
      type: Boolean,
    },
    step4: {
      type: Boolean,
    },
    step5: {
      type: Boolean,
    },
    step5alt: {
      type: Boolean,
    },
    step6: {
      type: Boolean,
    },
    step7: {
      type: Boolean,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.step-progress-bar {
  display: flex;
  justify-content: center;

  .step-wrapper {
    @include tablet-and-up-screen {
      max-width: 70%;
    }
  }

  .step-number-text {
    font-size: 1.25rem;
    line-height: 1.75rem;

    @include desktop-screen {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  .step-description-text {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;

    @include tablet-screen {
      font-size: 2.25rem;
      line-height: 2.8rem;
    }

    @include desktop-screen {
      font-size: 3rem;
      line-height: 3.75rem;
    }
  }
}
</style>
